import {Component, OnInit, OnDestroy} from '@angular/core';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.css']
})
export class ContactFormComponent implements OnInit, OnDestroy {

  constructor() { }

  ngOnInit() {
    $('.subHeader').addClass('subCoverAbout');
    $('.contactLink').addClass('activeLink');
    $('.contactLink a').css('color', 'white');
    $('.headline h1').text('CONTACT US');
  }

  ngOnDestroy() {
    $('.subHeader').removeClass('subCoverAbout');
    $('.contactLink').removeClass('activeLink');
  }

}



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/contactForm/contact-form.component.ts